import React from 'react'
import DetailsHeaderBar from '../components/DetailsHeaderBar'
import SideBar from '../components/SideBar'
import EditSection from '../components/EditSection'

function AdvertisingAgentEdit() {
  return (
    <div className="member-details-layout">
      <SideBar />
      <div className="member-details-main">
        <DetailsHeaderBar
            title="Edit Profile"
            subtitle="You can edit you details to upadate your profile"
            breadcrumbs={[
                {label: "Home", path: "/dashboard"},
                {label: "Manage Customer Advertising Agent", path: "/manage-advertising-agent"},
                {label: "Advertising Agent Details"}
            ]}
        />

        <EditSection/>
    </div>
    </div>
  )
}

export default AdvertisingAgentEdit